var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-listado',[_c('page-header',{attrs:{"title":"Formas de pago"}},[_c('b-button',{attrs:{"variant":"primary","size":"sm","to":"/formasPago/crear"}},[_c('v-icon',{attrs:{"name":"plus","width":"16"}}),_vm._v(" Crear forma de pago ")],1)],1),_c('tabla',{attrs:{"formas-pago":_vm.formasPago}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }